import { Action, combineReducers } from 'redux';

import { LOGOUT } from './auth/actions';
import auth from './auth/reducer';
import customerProducts from './customerProducts/reducer';
import customers from './customers/reducer';
import customerServices from './customerServices/reducer';
import locations from './locations/reducer';
import maintenanceStatuses from './maintenanceStatuses/reducer';
import manufacturers from './manufacturers/reducer';
import products from './products/reducer';
import roles from './roles/reducer';
import traffic from './traffic/reducer';
import vehicleTypes from './vehicleTypes/reducer';

const rootReducer = combineReducers({
  auth,
  products,
  locations,
  customers,
  customerProducts,
  customerServices,
  traffic,
  maintenanceStatuses,
  vehicleTypes,
  roles,
  manufacturers,
});

export default function(
  state: ReturnType<typeof rootReducer> | undefined,
  action: Action
) {
  // Reset the state on unauthentication
  if (action.type === LOGOUT) {
    state = undefined;
  }

  return rootReducer(state, action);
}
